var pluginsInits = function () {
    $('[data-id="alert"]').each(function () {
        new Announcements($(this)).init();
    });
};

(function ($) {

    'use strict';

    var Announcements = window.Announcements = function (container) {
        var _self = this;

        // Private Functions
        var addEvents = function () {
            container.on('click', 'button', function (evt) {
                evt.preventDefault(); 

                var announcmentId = container.data("announcementid");
                if (document.cookie.indexOf('preferences":"accepted') != -1) { 
                var cookieName = mando.strings.CookieName_Announcement + announcmentId;
                mando.setCookie(cookieName, "Closed", 365);
                }

                islington.giveScreenreaderAlert(`Notification has been removed: ${container.find('h2').text()}`, 'sr-announcement');
                container.fadeOut();
            });
        };

        // Public Functions
        _self.init = function () {
            if (container[0]) {
                addEvents();
            }
        };
    };
    })(jQuery);


